import { LoggerService } from "../services/logger/logger.service";

export function ExceptionHandler(target: any)
{
  const fileName = target.name;
  const methods = Object.getOwnPropertyNames(target.prototype);

  methods.forEach((method) =>
  {
    const descriptor = Object.getOwnPropertyDescriptor(
      target.prototype,
      method
    );

    if (descriptor && typeof descriptor.value === 'function' && !method.includes('track'))
    {
      const originalMethod = descriptor.value;

      descriptor.value = function (...args: any[])
      {
        const that = this;
        const logger: LoggerService = (that as any)['_logger'];

        if (!logger)
          throw new Error(`The '_logger' dependency is not initialized. Please initialize it in ${ fileName } before use.`);

        try
        {
          // console.log(`${ method } - ${ fileName }`);
          return originalMethod.apply(this, args);
        } catch (error)
        {
          console.error(`${ fileName } - Error in method ${ method }:`, error);
        }
      };

      Object.defineProperty(target.prototype, method, descriptor);
    }
  });
}